import React, { ReactElement } from "react";

import styled from "styled-components";

interface Props {}

export default function GetAccessInfo({}: Props): ReactElement {
  return (
    <Container className="center">
      <p>
        GET ACCESS to a modern, fast and advanced way to analyze Active Power
        Cycling (APC) data of your power modules. Visualize and aggregate all
        data to get your answers quickly.
      </p>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 50px;
  font-size: 15px;

  @media (min-width: 1000px) {
    font-size: 25px;
  }

  @media (min-width: 1200px) {
    font-size: 30px;
  }
`;
